import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useWizardWithData } from '../../../../../../../../core/hooks/WizardWithData';
import { AodRuleWizardValues } from '../../types';

export function WizardFinalizeBtn() {
  const { goToStep, stepCount, data } = useWizardWithData<AodRuleWizardValues>();

  if (!data.rule) {
    return null;
  }

  return null;

  return (
    <Button
      type="submit"
      variant="outlined"
      color="info"
      startIcon={<CheckCircleIcon />}
      onClick={() => goToStep(stepCount - 1)}
      data-finalize-btn="1"
    >
      <FormattedMessage id="common.wizard.finish" defaultMessage="Finalizar" />
    </Button>
  );
}
